module.exports = __webpack_public_path__ + "img/suncode.fc70fadb.jpg";